
<!-- 物料配套关系表 -->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form :formList="formList" @search="onSearch"></ls-search-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <import-excel ref="importExcel" @onChange="importChange" @onSuccess="handleSuccess" :url="importExcelUrl"></import-excel>
      <download-modal :apiFun="apiScpMpsItemRelationFdExport" ref="download" />
      <a-button @click="$refs.importExcel.show()" type="primary" v-if="$hasPermi(['fun_1833471308649811970_bDzOL'])">导入</a-button>
      <a-button @click="handleExport" type="primary" v-if="$hasPermi(['fun_1833471308649811970_NpiRd'])">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
        >
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiScpMpsItemRelationFdExport, apiSelectItemPage } from '@/api/finished-goods-order'

import { generateLsTableResData } from '@/utils/util.js';
import importExcel from './importExcel.vue'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
export default {
  // eslint-disable-next-line
  name: 'Material-support-relationship',
  components: {
    DownloadModal,
    importExcel
  },
  data () {
    return {
      apiScpMpsItemRelationFdExport,
      importExcelUrl: `/scp/scpMpsItemRelationFd/import`,
      warehouseOptions: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiSelectItemPage, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        supplierCode: undefined,
        supplierName: undefined,
        supplierClass: undefined,
        supplierAbbreviation: undefined,
        supplierBrevityCode: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      formList: [
        {
          label: '物料编码',
          type: "globalSelect-selectMultipleSearch",
          decorator: ['itemCodes'],
          attrs: {
            placeholder: '请选择物料编码',
            requestApi: '/mes/mesDiscreteJobs/assemblyBox',
            selectItem: { value: 'selectedValue', label: 'label' },
            searchParam: 'itemCode'
          }
        }
      ],
      // 表格字段
      columns: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '组编码',
          dataIndex: 'groupCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center'
        }
      ],
      uomClassOptions: [], // 来源分类
      unitOfMeasureList: [], // 来源单位
      unitOfMeasureListNew: [] // 基本单位
    }
  },
  created () {
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    handleSuccess() {
      this.onSearch();
    },
    importChange() {

    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.$nextTick(() => {
        const params = { ...this.queryParams }
        this.$refs.download.openModal(params)
      })
    },
    // 表单搜索
    onSearch (val) {
      this.queryParams = {};
      for(const key in val) {
        if(key !== 'searchFormLabel') {
          this.queryParams[key] = val[key]
        }
      }
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        uomClassList: undefined,
        unitOfMeasureList: undefined,
        baseUomList: undefined,
        status: undefined
      }
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
